/**
 * useSelectedHolder — Document Sign compatibility wrapper over the
 * platform-level `useHolderSwitcher` (`@/components/HolderSwitcher`).
 *
 * Selection is shared with every other arche so switching workspace in the
 * global header (or in Fias 360 / Fias Leads) is reflected here. Mirrors
 * the Fias Leads / Fias 360 wrapper so document-sign call sites match the
 * established arche pattern.
 *
 * Envelopes are holder-scoped at both the DB and API layers — the list
 * route filters by `(holder_id, holder_type)`. New envelopes are created
 * under the active holder; detail / builder / review pages remain pinned
 * to the envelope they were navigated to (the chip stays interactive but
 * doesn't redirect — switching while viewing an envelope just updates the
 * preference, the current view is unaffected).
 */

import { useHolderSwitcher } from '@/components/HolderSwitcher';

export function useSelectedHolder(): {
  holderId: string | null;
  setHolderId: (next: string | null) => void;
  isLoading: boolean;
  isError: boolean;
} {
  const switcher = useHolderSwitcher({ defaultToPersonal: true });
  return {
    holderId: switcher.selectedHolderId,
    setHolderId: switcher.setSelectedHolderId,
    isLoading: switcher.isLoading,
    isError: switcher.isError,
  };
}
